// extracted by mini-css-extract-plugin
export var actionButtonsContainer = "_cc-0";
export var actionModalContentContainer = "_cc-1";
export var createTagButton = "_cc-2";
export var footerContainer = "_cc-7";
export var fullWidthDivider = "_cc-3";
export var hasCreateTagButton = "_cc-4";
export var noCreateTagButton = "_cc-5";
export var tagsContainer = "_cc-6";
export var tagsModalContentContainer = "_cc-8";